import { Avatar, Stack, Typography } from "@mui/material"
import moment from "moment"
import { styles } from "./styles/NotifcationItem.styles"

export const NOTIFICATION_ACTION_TYPES = {
  1: "See my sticker",
  2: "View my reward",
  3: "Check my progress",
}

export default function NotificationItem({
  notificationId,
  title,
  content,
  date,
  avatar,
  notificationTypeId,
  actionButton,
  seen,
  argument1,
  groupId,
  onNotificationOpened,
}) {
  return (
    <Stack
      flexDirection={"row"}
      sx={[styles.notificationItem, !seen && styles.unreadNotification]}
      onClick={onNotificationOpened}
    >
      <Avatar src={avatar} sx={styles.avatar} />
      <Stack sx={styles.notificationItemContent}>
        <Typography
          variant="span"
          className="notification-item-title"
          sx={styles.notificationTitle}
        >
          {title}
        </Typography>
        <Typography
          variant="span"
          fontSize={14}
          sx={styles.notificationItemText}
        >
          {content}
        </Typography>
        <Typography
          variant="span"
          className="notification-item-date"
          sx={styles.notificationItemAction}
        >
          {actionButton}
        </Typography>
        <Typography
          variant="span"
          className="notification-item-date"
          sx={styles.notificationItemDate}
        >
          {moment(date).format("MMM DD, YYYY")}
        </Typography>
      </Stack>
    </Stack>
  )
}
